import LayoutMaster from "components/layout/layout_master";
import Ugame from "components/view/ugame";
import {
  CONTENT_HTML_TITLE_ALL_PROMOTION,
  CONTENT_TYPE_ID_CONTENT_OTHER,
} from "lib/all_type/content_type_id";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import get_all_content_by_prefix, {
  GetAllContentByPrefixResponse,
} from "lib/worker/api/get_all_content_by_prefix";
import { GetAllGamesResponseResult } from "lib/worker/api/get_all_game";
import get_promotion_available_for_member from "lib/worker/api/get_promotion_available_for_member";
import { GetServerSideProps } from "next";

interface Props {
  promotions: GetAllGamesResponseResult[];
  titlepromo: string | undefined;
  content: GetAllContentByPrefixResponse[];
  infomation: CheckWithPrefixResponse;
}

function AllUgame(props: Props) {
  const { infomation } = props;

  return (
    <LayoutMaster
      content_setting={{
        title: "uGame ทั้งหมด",
        description:
          "กิจกรรมจากทางเรา ufabet แจก udiamond เพื่อนำไปแลกเครดิตฟรี",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 10 }}>
        <Ugame information={infomation}></Ugame>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  try {
    const [promotions, content] = await Promise.all([
      get_promotion_available_for_member({
        token: context.req.cookies.access_token,
        prefix: infomation.prefix,
      }),
      get_all_content_by_prefix({
        prefix: infomation.prefix,
      }),
    ]);

    return {
      props: {
        infomation: infomation,
        promotions: promotions,
        content: content.filter(
          (a) =>
            a.ContentTypeID == CONTENT_TYPE_ID_CONTENT_OTHER &&
            a.Title == CONTENT_HTML_TITLE_ALL_PROMOTION
        ),
      },
    };
  } catch (error) {
    return {
      props: {
        promotions: [],
        content: [],
      },
    };
  }
};

export default AllUgame;
